






import {Component, Vue} from "vue-property-decorator";

class Dot {
  connectedTo;
  numConnections;
  threshold;
  index;
  xl; yl; xh; yh;
  x; y; vx; vy;

  constructor(i, instance, numDots, gRange, gSpeed) {
    this.connectedTo = new Array(numDots);
    this.numConnections = 0;
    this.threshold = 0.6;

    this.index = i;

    switch (this.index % 4) {
      case 0:
        this.xl = 0;
        this.yl = 0;
        this.xh = gRange;
        this.yh = gRange;
        break;
      case 1:
        this.xl = instance.width - gRange;
        this.yl = 0;
        this.xh = instance.width;
        this.yh = gRange;
        break;
      case 2:
        this.xl = instance.width - gRange;
        this.yl = instance.height - gRange;
        this.xh = instance.width;
        this.yh = instance.height;
        break;
      case 3:
        this.xl = 0;
        this.yl = instance.height - gRange;
        this.xh = gRange;
        this.yh = instance.height;
        break;
    }

    this.x = instance.random(this.xl, this.xh);
    this.y = instance.random (this.yl, this.yh);
    this.vx = (instance.random(2)-1)*gSpeed;
    this.vy = (instance.random(2)-1)*gSpeed;

    var n = (this.index + 1) % numDots;

    this.addConnection(n);

    this.newTemporaryConnections(instance, numDots);

    instance.rectMode(instance.CENTER);
  }

  addConnection(d) {
    this.connectedTo[this.numConnections] = d;
    this.numConnections++;
  }

  newTemporaryConnections(instance, numDots) {
    var alreadyConnected;
    var t;

    this.numConnections = 1;

    if (instance.random(1) > this.threshold) {
      do {
        t = (this.index + 2 + instance.floor(instance.random(numDots-2))) % numDots;

        alreadyConnected = false;
        for (var i = 0; i<this.numConnections; i++) {
          if (t == this.connectedTo[i]) {
            alreadyConnected = true;
            break;
          }
        }
      } while (alreadyConnected);

      this.addConnection(t);
    }
  }

  update(instance, numDots, dots) {
    instance.strokeWeight(1.2);

    for(var k= 0; k<this.numConnections; k++) {
      var c = this.connectedTo[k];
      instance.line(this.x, this.y, dots[c].x, dots[c].y);
    }

    this.x += this.vx;
    this.y += this.vy;

    if(this.x>=this.xh || this.x<=this.xl) {
      this.vx = -this.vx;
      this.x += this.vx;
      this.newTemporaryConnections(instance, numDots);
    }
    if(this.y>=this.yh || this.y<=this.yl) {
      this.vy = -this.vy;
      this.y += this.vy;
      this.newTemporaryConnections(instance, numDots);
    }
  }
}

@Component({})
export default class MiniRhizome extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  isMobile: boolean = false;
  numDots = 9;
  dots = [];

  created() {
    this.isMobile = window.matchMedia("(max-width: 576px)").matches;
  }

  setup(instance) {
    this.isMobile ? instance.createCanvas(36, 36) : instance.createCanvas(45, 45);
    instance.frameRate(24);

    instance.fill(244, 243, 240);
    instance.stroke('rgba(244, 243, 240, 0.8)');

    let gSpeed = 0.2;
    let gScale = instance.width / 40;
    gSpeed *= gScale;
    let gRange = instance.width * 0.5;

    for (var i = 0; i < this.numDots; i++) {
      this.dots[i] = new Dot(i, instance, this.numDots, gRange, gSpeed);
    }
  }

  draw(instance) {
    instance.clear();

    for (var i = 0; i < this.numDots; i++) {
      this.dots[i].update(instance, this.numDots, this.dots);
    }
  }
}
